import { gql } from '@apollo/client';

export const cableCodeFragments = {
  cableCodeItem: gql`
    fragment CableCodeItem on CableCode {
      id
      tag
      description
      physicalDiameter
      designatedDiameter
      physicalBundleWidth
      designatedBundleWidth
      numberOfConductors
      numberOfShields
      numberOfGrounds
      colorCodeId
      physicalArea
      tailLength
      weightPerUnit
      maxVoltage
      wireType
      conductorSize
      shieldSize
      groundSize
      configuration
      is4OughtAwgOrGreater
      jacketMaterial
      insulationMaterial
      manufacturer
      partNumber
      drawing
      gland
      insertblockId
      pullingBendRadius
      trainingBendRadius
      sideWallPressure
      pullingTensionBasket
      pullingTensionEye
      costCode
      termCostCode
      budgetQty
      pullingUnitPrice
      termUnitPrice
      stockCodeType
      stockCode
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      engineeringStatus
      revision
      ownerId
      preparedTime
      preparedBy
      checkedTime
      checkedBy
      approvedTime
      approvedBy
      serviceLevelId1
      serviceLevelId2
      serviceLevelId3
      serviceLevelId4
      serviceLevelId5
      serviceLevelId6
      serviceLevel1 {
        id
        name
      }
      serviceLevel2 {
        id
        name
      }
      serviceLevel3 {
        id
        name
      }
      serviceLevel4 {
        id
        name
      }
      serviceLevel5 {
        id
        name
      }
      serviceLevel6 {
        id
        name
      }
      colorCode {
        id
        tag
      }
      insertBlock {
        id
        tag
        grooveDiaEnglish
      }
      updatedTime
      updatedBy
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      approvedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      checkedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      preparedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  `,
};

export const CREATE_CABLE_CODE = gql`
  ${cableCodeFragments.cableCodeItem}
  mutation CreateCableCode($createCableCodeInput: CreateCableCodeInput!) {
    createCableCode(createCableCodeInput: $createCableCodeInput) {
      cableCode {
        ...CableCodeItem
      }
      errors
    }
  }
`;

export const DELETE_CABLE_CODE = gql`
  mutation DeleteCableCode($deleteCableCodeInput: DeleteCableCodeInput!) {
    deleteCableCode(deleteCableCodeInput: $deleteCableCodeInput) {
      id
      errors
    }
  }
`;

export const UPDATE_CABLE_CODE = gql`
  ${cableCodeFragments.cableCodeItem}
  mutation UpdateCableCode($updateCableCodeInput: UpdateCableCodeInput!) {
    updateCableCode(updateCableCodeInput: $updateCableCodeInput) {
      cableCode {
        ...CableCodeItem
      }
      infos
      errors
    }
  }
`;

export const UPDATE_CABLE_CODES = gql`
  ${cableCodeFragments.cableCodeItem}
  mutation UpdateCableCodes($updateCableCodesInput: [UpdateCableCodeInput!]!) {
    updateCableCodes(updateCableCodesInput: $updateCableCodesInput) {
      cableCodes {
        ...CableCodeItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_CABLE_CODE_BY_ID = gql`
  ${cableCodeFragments.cableCodeItem}
  query CableCodeById($id: ID!) {
    cableCodeById(id: $id) {
      ...CableCodeItem
    }
  }
`;

export const GET_CABLE_CODE_BY_IDS = gql`
  ${cableCodeFragments.cableCodeItem}
  query CableCodeByIds($ids: [ID!]!) {
    cableCodeByIds(ids: $ids) {
      ...CableCodeItem
    }
  }
`;

export const SEARCH_INSERT_BLOCKS = gql`
  query SearchInsertblocks($searchInput: SearchInput) {
    searchInsertblocks(searchInput: $searchInput) {
      items {
        id
        projectId
        tag
        grooveDiaEnglish
        grooveDiaMetric
        updatedTime
        updatedBy
      }
    }
  }
`;

export const ISSUE_CABLE_CODES = gql`
  ${cableCodeFragments.cableCodeItem}
  mutation IssueCableCodes($issueCableCodesInput: [IssueCableCodeInput!]!) {
    issueCableCodes(issueCableCodesInput: $issueCableCodesInput) {
      cableCodes {
        ...CableCodeItem
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;
